export default {
  selected: (state) => state.selected,
};
